import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'weekDay'
})
export class WeekDayPipe implements PipeTransform {

  private daysOfWeek: Array<string> = new Array<string>(
    "Lundi",
    "Mardi",
    "Mercredi",
    "Jeudi",
    "Vendredi",
    "Samedi",
    "Dimanche"
  );

  transform(value: number, args?: any): string {
    if(value > 0 && value < 8){
      return this.daysOfWeek[--value];
    }
    return undefined;
  }

}
